/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSchoolFeesDiscountRequest } from '../models/CreateSchoolFeesDiscountRequest';
import type { DiscountItemDto } from '../models/DiscountItemDto';
import type { ImportDiscountDto } from '../models/ImportDiscountDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SchoolFeesDiscountRestControllerService {
  /**
   * getSchoolFeesDiscount
   * @returns DiscountItemDto OK
   * @throws ApiError
   */
  public static getSchoolFeesDiscountUsingGet({
    studentId,
    month,
    termId,
    year,
  }: {
    /**
     * student-id
     */
    studentId: string;
    /**
     * month
     */
    month?:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * term-id
     */
    termId?: string;
    /**
     * year
     */
    year?: number;
  }): CancelablePromise<Array<DiscountItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/school-fees-discounts',
      query: {
        month: month,
        'student-id': studentId,
        'term-id': termId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createSchoolFeesDiscount
   * @returns DiscountItemDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createSchoolFeesDiscountUsingPost({
    createSchoolFeesDiscountRequest,
  }: {
    /**
     * createSchoolFeesDiscountRequest
     */
    createSchoolFeesDiscountRequest: CreateSchoolFeesDiscountRequest;
  }): CancelablePromise<Array<DiscountItemDto> | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/school-fees-discounts',
      body: createSchoolFeesDiscountRequest,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteSchoolFeesDiscount
   * @returns any OK
   * @throws ApiError
   */
  public static deleteSchoolFeesDiscountUsingDelete({
    payableItemId,
    studentId,
    month,
    termId,
    year,
  }: {
    /**
     * payable-item-id
     */
    payableItemId: string;
    /**
     * student-id
     */
    studentId: string;
    /**
     * month
     */
    month?:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * term-id
     */
    termId?: string;
    /**
     * year
     */
    year?: number;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/school-fees-discounts',
      query: {
        month: month,
        'payable-item-id': payableItemId,
        'student-id': studentId,
        'term-id': termId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * importDiscount
   * @returns any OK
   * @throws ApiError
   */
  public static importDiscountUsingPost({
    discountDto,
  }: {
    /**
     * discountDto
     */
    discountDto: ImportDiscountDto;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/school-fees-discounts/import',
      body: discountDto,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getByStudentAndTerm
   * @returns DiscountItemDto OK
   * @throws ApiError
   */
  public static getByStudentAndTermUsingGet({
    studentId,
    month,
    termId,
    year,
  }: {
    /**
     * student-id
     */
    studentId: string;
    /**
     * month
     */
    month?:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * term-id
     */
    termId?: string;
    /**
     * year
     */
    year?: number;
  }): CancelablePromise<Array<DiscountItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/school-fees-discounts/{student-id}',
      path: {
        'student-id': studentId,
      },
      query: {
        month: month,
        'term-id': termId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
